/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_FallbackInputs */

const th_video_fallback = /** @type {(inputs: Video_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังใช้โหมดความเข้ากันได้ เปิดหน้านี้ไว้เพื่อให้วิดีโอทำงานต่อเนื่อง`)
};

const en_video_fallback = /** @type {(inputs: Video_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Using a compatibility mode. Keep this page visible for reliable video.`)
};

const ja_video_fallback = /** @type {(inputs: Video_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`互換モードを使用しています。映像を安定させるため、このページを表示したままにしてください。`)
};

const zh_video_fallback = /** @type {(inputs: Video_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在使用兼容模式。请保持此页面可见，以便画面稳定。`)
};

const es_video_fallback = /** @type {(inputs: Video_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usando un modo de compatibilidad. Mantén esta página visible para que el vídeo sea estable.`)
};

const pt_video_fallback = /** @type {(inputs: Video_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usando um modo de compatibilidade. Mantenha esta página visível para o vídeo ficar estável.`)
};

const id_video_fallback = /** @type {(inputs: Video_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memakai mode kompatibilitas. Biarkan halaman ini terlihat agar video tetap stabil.`)
};

const fr_video_fallback = /** @type {(inputs: Video_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mode de compatibilité utilisé. Gardez cette page visible pour une vidéo fiable.`)
};

const tl_video_fallback = /** @type {(inputs: Video_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gumagamit ng compatibility mode. Panatilihing nakikita ang pahinang ito para manatiling matatag ang video.`)
};

const vi_video_fallback = /** @type {(inputs: Video_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang dùng chế độ tương thích. Giữ trang này hiển thị để video ổn định.`)
};

const ko_video_fallback = /** @type {(inputs: Video_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`호환 모드를 쓰고 있습니다. 영상이 안정적이도록 이 페이지를 계속 보이게 두세요.`)
};

const de_video_fallback = /** @type {(inputs: Video_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es wird ein Kompatibilitätsmodus genutzt. Halte diese Seite sichtbar, damit das Video stabil bleibt.`)
};

const ru_video_fallback = /** @type {(inputs: Video_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Используется режим совместимости. Держите эту страницу открытой, чтобы видео шло стабильно.`)
};

const tr_video_fallback = /** @type {(inputs: Video_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uyumluluk modu kullanılıyor. Görüntünün düzgün kalması için bu sayfayı görünür tutun.`)
};

const it_video_fallback = /** @type {(inputs: Video_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`È in uso la modalità di compatibilità. Tieni visibile questa pagina perché il video resti stabile.`)
};

const pl_video_fallback = /** @type {(inputs: Video_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Używany jest tryb zgodności. Trzymaj tę stronę widoczną, aby obraz był stabilny.`)
};

const uk_video_fallback = /** @type {(inputs: Video_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Використовується режим сумісності. Тримайте цю сторінку видимою, щоб відео було стабільним.`)
};

const hi_video_fallback = /** @type {(inputs: Video_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संगतता मोड का उपयोग हो रहा है। वीडियो स्थिर रहे इसके लिए यह पृष्ठ दिखता रहने दें।`)
};

const ar_video_fallback = /** @type {(inputs: Video_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يُستخدم وضع التوافق. أبقِ هذه الصفحة ظاهرة ليبقى الفيديو مستقرًا.`)
};

const ms_video_fallback = /** @type {(inputs: Video_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menggunakan mod keserasian. Biarkan halaman ini kelihatan supaya video kekal stabil.`)
};

const bn_video_fallback = /** @type {(inputs: Video_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সামঞ্জস্য মোড ব্যবহার হচ্ছে। ভিডিও স্থির রাখতে এই পৃষ্ঠা দৃশ্যমান রাখুন।`)
};

const zh_tw2_video_fallback = /** @type {(inputs: Video_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在使用相容模式。請讓這個頁面保持可見，以維持影片穩定。`)
};

const zh_hk2_video_fallback = /** @type {(inputs: Video_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在使用相容模式。請讓這個頁面保持可見，以維持短片穩定。`)
};

const ur_video_fallback = /** @type {(inputs: Video_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مطابقت والا انداز استعمال ہو رہا ہے۔ ویڈیو مستحکم رکھنے کے لیے یہ صفحہ نظر میں رکھیں۔`)
};

const fa_video_fallback = /** @type {(inputs: Video_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`از حالت سازگاری استفاده می‌شود. برای پایداری تصویر این صفحه را در دید نگه دارید.`)
};

const sw_video_fallback = /** @type {(inputs: Video_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inatumia hali ya uendanaji. Iache kurasa hii ionekane ili video ibaki thabiti.`)
};

const nl_video_fallback = /** @type {(inputs: Video_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er wordt een compatibiliteitsmodus gebruikt. Houd deze pagina zichtbaar zodat het beeld stabiel blijft.`)
};

/**
* | output |
* | --- |
* | "Using a compatibility mode. Keep this page visible for reliable video." |
*
* @param {Video_FallbackInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const video_fallback = /** @type {((inputs?: Video_FallbackInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_FallbackInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_video_fallback(inputs)
	if (locale === "ja") return ja_video_fallback(inputs)
	if (locale === "zh") return zh_video_fallback(inputs)
	if (locale === "es") return es_video_fallback(inputs)
	if (locale === "pt") return pt_video_fallback(inputs)
	if (locale === "id") return id_video_fallback(inputs)
	if (locale === "fr") return fr_video_fallback(inputs)
	if (locale === "tl") return tl_video_fallback(inputs)
	if (locale === "vi") return vi_video_fallback(inputs)
	if (locale === "ko") return ko_video_fallback(inputs)
	if (locale === "de") return de_video_fallback(inputs)
	if (locale === "ru") return ru_video_fallback(inputs)
	if (locale === "tr") return tr_video_fallback(inputs)
	if (locale === "it") return it_video_fallback(inputs)
	if (locale === "pl") return pl_video_fallback(inputs)
	if (locale === "uk") return uk_video_fallback(inputs)
	if (locale === "hi") return hi_video_fallback(inputs)
	if (locale === "ar") return ar_video_fallback(inputs)
	if (locale === "ms") return ms_video_fallback(inputs)
	if (locale === "bn") return bn_video_fallback(inputs)
	if (locale === "zh-TW") return zh_tw2_video_fallback(inputs)
	if (locale === "zh-HK") return zh_hk2_video_fallback(inputs)
	if (locale === "ur") return ur_video_fallback(inputs)
	if (locale === "fa") return fa_video_fallback(inputs)
	if (locale === "sw") return sw_video_fallback(inputs)
	if (locale === "nl") return nl_video_fallback(inputs)
	return en_video_fallback(inputs)
});